<template>
  <div>
    <label>
      {{ index }}.
      {{ question }}
    </label>
    <section class="mx-3">
      <p v-if="!responses||responses.length==0" class="text-muted small">
        <i class="material-icons align-middle small">
          error_outline
        </i>
        No answer
      </p>
      <p v-for="item in responses" :key="item.id" class="text-main">
        {{ convertAMPM(item.answer_text_1) }}
      </p>
      <b-link v-if="onModal" class="d-flex text-left pt-2" :href="('/skill-planning/'+getSkillName.id)" >
        Go to the plan to edit your answer
      </b-link>
    </section>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    responses: Array,
    question: String,
    index: Number,
    id: Number,
    onModal: {
      type:Boolean,
      default:false
    }
  },
  computed: {
    ...mapGetters("planning", [
      "getSkillName",
    ]),
  },
  methods: {
    convertAMPM(time) {
      time = time.slice(0, -3);
      // Check correct time format and split into components
      time = time
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

      if (time.length > 1) {
        // If time format correct
        time = time.slice(1); // Remove full string match value
        time[5] = +time[0] < 12 ? "AM" : "PM"; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      return time.join(""); // return adjusted time or original string
    }
  }
};
</script>
